// extracted by mini-css-extract-plugin
module.exports = {"varIndigo600":"var(--tkww-union-color-indigo-600, var(--tkww-union-color-additional-01extra-200, #C4DFF9))","removeItem":"removeItem--7ec47"};